<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col class="content_inner">
        <div class="margin-bottom-2x">
          <span @click="back" class="curson-pointer font-size-14 text-body-2"> <v-icon left style="margin-right: 0">mdi-chevron-left</v-icon>返回 </span>
        </div>
        <v-card class="form-card card-padding">
          <h2 class="card-title">{{ code ? "编辑菜单" : "添加菜单" }}</h2>
          <v-tabs v-model="tabValue">
            <v-tab key="base">基础信息</v-tab>
            <!-- <v-tab key="detail">配置图文介绍</v-tab>
            <v-tab key="extraConfig">安装配置</v-tab> -->
          </v-tabs>
          <v-card-text>
            <!-- <p>{{form}}</p> -->
            <v-form v-model="valid" ref="form">
              <ul v-show="tabValue === 0" class="form-ul label-width-7">
                <li class="required">
                  <span class="label">菜单code：</span>
                  <div class="v-input-box">
                    <v-text-field ref="appCode" placeholder="请输入" v-model="form.code" solo required :rules="rules.code"></v-text-field>
                  </div>
                </li>
                <li class="required">
                  <span class="label">名称：</span>
                  <div class="v-input-box">
                    <v-text-field ref="appName" placeholder="请输入" v-model="form.name" solo required :rules="rules.name" :error-messages="errorMessages"></v-text-field>
                  </div>
                </li>
                <li class="required">
                  <span class="label">英文名称：</span>
                  <div class="v-input-box">
                    <v-text-field ref="appNameEn" placeholder="请输入" v-model="form.nameEn" solo required :rules="rules.nameEn" :error-messages="errorMessages"></v-text-field>
                  </div>
                </li>
                <li>
                  <span class="label">用户类型：</span>
                  <div class="v-input-box">
                    <!-- <v-radio-group v-model="form.userType" mandatory row>
                      <v-radio v-for="item in userTypeList" :key="item.id" :label="item.name" :value="item.label"></v-radio>
                    </v-radio-group> -->
                    <div v-for="(item, key) in userTypeList" :key="key" class="chieck-box-inline">
                      <v-checkbox v-model="form.userTypeArr" :label="item.name" :value="item.label" :rules="rules.userTypeArr" ></v-checkbox>
                    </div>
                  </div>
                </li>
                <li>
                  <span class="label">平台类型：</span>
                  <div class="v-input-box" v-if="platTypeList.length > 0">
                    <div v-for="(item, key) in platTypeList" :key="key" class="chieck-box-inline">
                      <v-checkbox v-model="form.platTypeArr" :label="item.name" :value="item.code" :rules="rules.platTypeArr" @change="changePlatType"></v-checkbox>
                    </div>
                  </div>
                </li>
                <!-- <p>{{selectedPlat}}</p> -->
                <!-- <p>{{iconModeList}}</p>
                <p>{{imgFile}}</p> -->
                <li class="li-file" v-for="(item, key) in selectedPlat" :key="key">
                  <span class="label">{{ item.name }}图标：</span>
                  <div class="v-input-box">
                    <div class="upload-box" v-for="(subItem, key) in iconModeList[item.code]" :key="key">
                      <div class="inner">
                        <p style="font-size: 12px">{{ subItem.name }}</p>
                        <v-avatar class="img" size="62" rounded="0">
                          <img v-if="imgFile[item.code][subItem.code].base64 || imgFile[item.code][subItem.code].url" :src="imgFile[item.code][subItem.code].base64 || imgFile[item.code][subItem.code].url" alt="图标" />
                          <v-icon v-else x-large>mdi-camera</v-icon>
                        </v-avatar>
                      </div>
                      <v-file-input @change="changeFile($event, subItem.code, item.code)" filled accept="image/png, image/jpeg, image/bmp" prepend-icon="mdi-camera" solo></v-file-input>
                      <span class="delete" @click="deleteImg(subItem.code, item.code)">删除</span>
                    </div>
                  </div>
                </li>
                <!-- {{selectedPlat}} -->
                <li class="li-url" v-if="selectedPlat.length > 0">
                  <span class="label">菜单地址：</span>
                  <div class="v-input-box">
                    <div v-for="(item, key) in selectedPlat" :key="key">
                      <h4 style="margin-top: 6px">{{ item.name }}</h4>
                      <div v-if="item.children.length > 0" class="input-group-nomargin">
                        <div v-for="(o, key) in item.children" :key="key">
                          <v-text-field v-if="o.appIdRequired === 0 && o.routingParameters === 0" ref="name" placeholder="请输入" v-model="o.url" solo>
                            <template v-slot:prepend-inner>
                              <span>{{ o.name }}</span>
                            </template>
                          </v-text-field>
                          <div v-else class="file-group">
                            <div class="file-group-title">
                              <span>{{ o.name }}</span>
                            </div>
                            <v-text-field v-if="o.appIdRequired === 1" ref="name" class="no-bottom-field" placeholder="请输入Appid" v-model="o.appId" solo></v-text-field>
                            <v-text-field ref="name" class="no-bottom-field-next" placeholder="请输入页面路径" v-model="o.url" solo></v-text-field>
                            <v-text-field ref="name" v-if="o.routingParameters === 1" class="no-bottom-field" placeholder="请输入route" v-model="o.route" solo></v-text-field>
                          </div>
                        </div>
                      </div>
                      <div v-else style="overflow: hidden">
                        <v-text-field v-if="item.appIdRequired === 0 && item.routingParameters === 0" ref="name" placeholder="请输入" v-model="item.url" solo>
                          <template v-slot:prepend-inner>
                            <span>{{ item.name }}</span>
                          </template>
                        </v-text-field>
                        <div v-else class="file-group">
                          <div class="file-group-title">
                            <span>{{ item.name }}</span>
                          </div>
                          <v-text-field v-if="item.appIdRequired === 1" ref="name" class="no-bottom-field" placeholder="请输入Appid" v-model="item.appId" solo></v-text-field>
                          <v-text-field ref="name" class="no-bottom-field-next" placeholder="请输入页面路径" v-model="item.url" solo></v-text-field>
                          <v-text-field v-if="item.routingParameters === 1" ref="name" class="no-bottom-field" placeholder="请输入route" v-model="item.route" solo></v-text-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <!-- <li class="url-box" v-if="selectedPlat.length > 0">
                  <span class="label">菜单地址：</span>
                  <div class="v-input-box">
                    <div v-for="(item, key) in selectedPlat" :key="key">
                      <h4 style="margin-top:6px;" v-if="item.routingParameters">{{item.name}}</h4>
                      <v-text-field v-if="!item.routingParameters" ref="name"  placeholder="请输入" v-model="item.url" solo>
                        <template v-slot:prepend-inner>
                          <span>{{item.name}}</span>
                        </template>
                      </v-text-field>
                      <div class="input-group-nomargin" v-else>
                        <v-text-field  ref="name"  placeholder="请输入" v-model="item.url" solo>
                          <template v-slot:prepend-inner>
                            <span>地址</span>
                          </template>
                        </v-text-field>
                        <v-text-field  ref="name"  placeholder="请输入" v-model="item.route" solo>
                          <template v-slot:prepend-inner>
                            <span>路由</span>
                          </template>
                        </v-text-field>
                      </div>
                    </div>
                  </div>
                </li> -->
                <!-- <li>
                  <span class="label">说明：</span>
                  <div class="v-input-box">
                    <v-textarea rows="2" placeholder="请输入" v-model="form.description" solo></v-textarea>
                  </div>
                </li> -->
              </ul>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn large class="ma-2 white--text btn-large" color="blue" style="margin: 0 auto !important" @click="submit">确定</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { buildAxios } from '@/plugins/axios'
import { handleResponse } from '@/plugins/errorHandler'
const request = buildAxios()
export default {
  components: {
  },
  data () {
    return {
      code: this.$route.query.code,
      tabValue: 0,
      errorMessages: '',
      // uploadFile: null,
      valid: true,
      rules: {
        code: [
          v => !!v || '请填写code',
          v => v.length <= 50 || 'code 不能超过20个字符长度'
        ],
        name: [
          v => !!v || '请填写菜单名称'
        ],
        nameEn: [
          v => !!v || '请填写菜单英文名称'
        ],
        platTypeArr: [
          v => v.length >= 1 || '请选择平台类型'
        ],
        userTypeArr: [
          v => v.length >= 1 || '请选择用户类型'
        ]
      },
      selectedPlat: [],
      form: {
        code: '',
        name: '',
        nameEn: '',
        platTypeArr: [],
        // userType: '',
        userTypeArr: []
        // description: ''
      },
      info: {},
      fileFlag: false, // 编辑文件
      imgFile: null
      // imgFile: {
      //   mobile: {
      //     white: {
      //       base64: null,
      //       url: null
      //     },
      //     check: {
      //       base64: null,
      //       url: null
      //     },
      //     black: {
      //       base64: null,
      //       url: null
      //     }
      //   },
      //   pc: {
      //     white: {
      //       base64: null,
      //       url: null
      //     }
      //   },
      //   selfService: {
      //     white: {
      //       base64: null,
      //       url: null
      //     }
      //   }
      // }
      // iconList: [{
      //   code: 'white',
      //   name: '正常模式'
      // }, {
      //   code: 'check',
      //   name: '选中状态'
      // }, {
      //   code: 'black',
      //   name: '深色模式'
      // }]
      // isEditorShow: false,
      // jsonDialog: false,
      // platTypeList: []
    }
  },
  computed: {
    ...mapState(['platTypeList', 'userTypeList', 'componentTypeList', 'iconDirectoryList', 'iconModeList'])
    // getDefaultContent () {
    //   return cloneDeep(this.defaultContent) // 【注意】深度拷贝 defaultContent ，否则会报错
    // }
  },
  watch: {
  },
  beforeDestroy () {
    // const editor = getEditor(this.editorId)
    // if (editor == null) return
    // editor.destroy()
    // removeEditor(this.editorId)
  },
  created () {
  },
  mounted () {
    // console.log(555555, 'platTypeList-----------', this.platTypeList)
    this.imgFile = {}
    for (const key in this.iconModeList) {
      // console.log(key, this.iconModeList[key])
      // this.imgFile[key] =
      this.$set(this.imgFile, key, {})
      this.iconModeList[key].forEach(element => {
        this.$set(this.imgFile[key], element.code, { base64: null, url: null })
      })
    }
    console.log('this.imgFile', this.imgFile)
    if (this.code) {
      this.menu = JSON.parse(sessionStorage.getItem('menuDetail'))
      this.form = {
        code: this.menu.code,
        name: this.menu.name,
        nameEn: this.menu.nameEn,
        platTypeArr: this.menu.platType ? this.menu.platType.split(',') : []
        // userTypeArr: this.menu.userType ? this.menu.userType.split(',') : []
        // userType: this.menu.userType
        // extraConfig: this.menu.extraConfig
        // description: data.description
      }
      const arr = []
      if (this.menu.userType === 'common') {
        this.userTypeList.forEach((element) => {
          arr.push(element.label)
        })
      } else {
        arr.push(this.menu.userType)
      }
      this.$set(this.form, 'userTypeArr', arr)
      if (this.menu.extraConfig.iconUrlMap) {
        for (const key in this.imgFile) {
          // this.imgFile[key]
          for (const j in this.imgFile[key]) {
            if (this.menu.extraConfig.iconUrlMap[key]) this.imgFile[key][j].url = this.menu.extraConfig.iconUrlMap[key][j]
          }
        }
      }
      this.selectedPlat = this.platTypeList.filter(item => {
        return this.form.platTypeArr.indexOf(item.code) !== -1
      })
      // console.log(666, 'selectedPlat--------', this.selectedPlat, this.menu.extraConfig.url)
      this.selectedPlat.forEach((element, index) => {
        const o = this.menu.extraConfig.url.filter(item => {
          // const obj = {}
          if (item.parentCode) {
            return item.parentCode === element.code
          } else {
            return item.code === element.code
          }
          // return item.parentCode === element.code
        })
        if (element.children && element.children.length > 0) {
          element.children.forEach((ec, i) => {
            const oh = o.find(item => {
              return ec.code === item.code
            })
            ec.url = oh.url
            if (ec.appIdRequired === 1) ec.appId = oh.appId ? oh.appId : null
            if (ec.routingParameters === 1) ec.route = oh.route ? oh.route : null
            // console.log(88888, ec)
          })
        } else {
          console.log('this.selectedPlat', element, o)
          const oh = o.find(item => {
            return element.code === item.code
          })
          element.url = oh.url
          if (element.appIdRequired === 1) element.appId = oh.appId ? oh.appId : null
          if (element.routingParameters === 1) element.route = oh.route ? oh.route : null
          // this.selectedPlat[index] = element
          // console.log('this.selectedPlat--', this.selectedPlat)
        }
        // element.url = this.menu.extraConfig.urlMap[element.code]
        // element.route = this.menu.extraConfig.routeMap ? this.menu.extraConfig.routeMap[element.code] : ''
      })
    }
    // this.platTypeList = this.platType
    // if (this.appCode) {
    //   this.getHistory()
    // } else {
    //   this.isEditorShow = true
    // }
  },
  methods: {
    back () {
      this.$router.back(-1)
    },
    // upload
    changeFile (file, model, plat) {
      if (!this.form.code) {
        this.$emit('alert', {
          msg: '请先输入菜单code！',
          type: 'error'
        })
        return false
      }
      console.log('changeFile', file)
      if (file) {
        // this.imgFile[code] =
        //   this.form.file = file
        const fileReader = new FileReader()
        fileReader.readAsDataURL(file)
        fileReader.onload = (e) => {
          console.log(e.target)
          this.imgFile[plat][model].base64 = e.target.result
          this.uploadFile(file, model, plat)
        }
      } else {
        this.imgFile[plat][model].base64 = null
      }
      console.log(this.imgFile)
    },
    // platType
    changePlatType (val) {
      // this.form.platType = val
      this.selectedPlat = this.platTypeList.filter(item => {
        return val.indexOf(item.code) !== -1
      })
      console.log(this.form.platTypeArr)
      // console.log(arr)
    },
    uploadFile (file, model, plat) {
      const formData = new FormData()
      formData.append('iconName', plat + '$' + model + '$' + this.form.code)
      formData.append('iconType', 'index')
      formData.append('file', file)
      // /cloud-api/baseIcon/addIcon
      request.defaults.headers['content-type'] = 'multipart/form-data'
      request.post('baseIcon/addIcon', formData).then(res => {
        // console.log(res)
        this.imgFile[plat][model].url = res.data.data.url
        // this.$router.push({ name: 'componentList' })
        // console.log('uploadFile', this.imgFile)
      }).catch(reason => {
        this.$emit('alert', {
          msg: handleResponse(reason.response),
          type: 'error'
        })
      })
    },
    deleteImg (model, plat) {
      // const key = type + 'IconFile'
      this.imgFile[plat][model].base64 = null
      this.imgFile[plat][model].url = null
      // console.log('deleteImg', this.imgFile)
      // this.form[key] = ''
    },
    // submit
    submit () {
      // console.log(this.form)
      // console.log(this.imgFile)
      // console.log(this.selectedPlat)
      if (!this.code && !this.$refs.form.validate()) { // 添加
        this.$emit('alert', {
          msg: '表单填写有误！',
          type: 'error'
        })
        return false
      }
      if (this.code && !this.$refs.form.validate()) { // 编辑
        this.$emit('alert', {
          msg: '表单填写有误！',
          type: 'error'
        })
        return false
      }
      console.log('this.imgFile', this.imgFile)
      const iconUrlMap = {}
      if (this.imgFile) {
        Object.keys(this.imgFile).forEach((key) => {
          if (this.form.platTypeArr.indexOf(key) !== -1) {
            iconUrlMap[key] = {}
            Object.keys(this.imgFile[key]).forEach((key1) => {
              iconUrlMap[key][key1] = this.imgFile[key][key1].url
            })
          }
        })
      }
      console.log('iconUrlMap-------', iconUrlMap)
      // uploadFile
      // const img = []
      const url = []
      // const routeMap = {}
      // const extraConfig = []
      this.selectedPlat.forEach(element => {
        if (element.children.length > 0) {
          element.children.forEach(subEle => {
            url.push(subEle)
          })
        } else {
          url.push(element)
        }
        // if (element.url) this.$set(urlMap, element.code, element.url)
        // this.$set(iconUrlMap, element.code, {})
        //   if (element.route) this.$set(routeMap, element.code, element.route)
        // for (const model in this.imgFile[element.code]) {
        //   if (this.imgFile[element.code][model].url) {
        //     this.$set(img[element.code], model, this.imgFile[element.code][model].url)
        //   }
        //   // if (this.imgFile[element.code][model].route) {
        //   //   this.$set(routeMap[element.code], model, this.imgFile[element.code][model].route)
        //   // }
        // }
      })
      // alert(JSON.stringify(this.form.platTypeArr))
      console.log('', this.form.platTypeArr)
      if (this.form.userTypeArr.length > 1) {
        this.$set(this.form, 'userType', 'common')
      } else {
        this.$set(this.form, 'userType', this.form.userTypeArr[0])
      }
      this.$set(this.form, 'platType', this.form.platTypeArr.join(','))
      // this.$set(this.form, 'userType', this.form.userTypeArr.join(','))
      this.$set(this.form, 'extraConfig', { url, iconUrlMap })

      console.log('this.form---------', this.form)
      const params = JSON.parse(JSON.stringify(this.form))
      this.$delete(params, 'platTypeArr')
      this.$delete(params, 'userTypeArr')
      // console.log(this.form, iconUrlMap, urlMap)
      // console.log(this.form, iconList, urlList)
      if (this.code) { // 编辑
        this.editSubmit(params)
      } else { // 添加
        this.addSubmit(params)
      }
    },
    // add
    addSubmit (data) {
      // Content-Type: application/json;charset=UTF-8
      // console.log('request--', request)
      // request.defaults.headers['content-type'] = 'multipart/form-data'
      request.defaults.headers['content-type'] = 'application/json;charset=UTF-8'
      request.post('baseIndex/add', data).then(res => {
        this.$router.push({ name: 'menuList' })
      }).catch(reason => {
        this.$emit('alert', {
          msg: handleResponse(reason.response),
          type: 'error'
        })
      })
    },
    fileEdit () {
      this.fileFlag = !this.fileFlag
    },
    editSubmit (data) {
      // const request = buildAxios()
      // request.defaults.headers['content-type'] = 'multipart/form-data'
      // /cloud-api/baseIndex/update\
      console.log(data)
      request.defaults.headers['content-type'] = 'application/json;charset=UTF-8'
      console.log('request--', request.defaults.headers)
      request.post('baseIndex/update', data).then(res => {
        this.$router.push({ name: 'menuList' })
      }).catch(reason => {
        this.$emit('alert', {
          msg: handleResponse(reason.response),
          type: 'error'
        })
      })
    }
  }
}
</script>
<style>
.url-box .v-input__control {
  height: 46px;
}
</style>
